import { useCallback, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

type WorkdayLogHoursModalState = {
  isOpen: boolean;
  isStatusRefreshing: boolean;
  openModal: () => void;
  closeModal: () => void;
  setStatusRefreshing: (isRefreshing: boolean) => void;
};

const noop = () => {};

/**
 * Shared open state so the "Clock work hours" button on NewDashboard can drive
 * the modal that OverviewRoute mounts alongside it.
 */
const useWorkdayLogHoursModal = singletonHook<WorkdayLogHoursModalState>(
  {
    isOpen: false,
    isStatusRefreshing: false,
    openModal: noop,
    closeModal: noop,
    setStatusRefreshing: noop,
  },
  () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isStatusRefreshing, setStatusRefreshing] = useState(false);
    const openModal = useCallback(() => setIsOpen(true), []);
    const closeModal = useCallback(() => setIsOpen(false), []);

    return {
      isOpen,
      isStatusRefreshing,
      openModal,
      closeModal,
      setStatusRefreshing,
    };
  },
);

export { useWorkdayLogHoursModal };
export type { WorkdayLogHoursModalState };
